import { GetApp } from "../../App"
import { GetCruise } from "../../App/Context"
import { Icon, Icons } from "../../Components/Icon"
import { TabBar } from "../../Components/TabBar"
import { BlockRow } from "../../Components/Block"
import { INoteParentType } from "../../Types"
import { StatsView } from "../StatsView"
import { TrackView } from "../TrackView"
import { GraphView } from "../GraphView"
import { NoteTabs } from "../NoteView"
import { TripEditView } from "../TripEditView"
import { GetShipView } from "../ShipView"
import { PrintMode } from "../PrintView"
import { TripDetailsViewProps } from "./Params"
import { useTripData } from "./DataContext"

// The TripView details region: the TabBar with the trip/stats/track/weather/note/print
// tabs. Presentational — reads its app/cruise/ship-view context directly and takes the
// TabBar handle, its initial selection and the loaded track list from the root. Keeps the
// original TripView-details / -track / -print-tab class names.
export function TripDetailsView({ trip, initTab, tabBarRef, tracks }: TripDetailsViewProps) {
  const app = GetApp();
  const { cruise } = GetCruise();
  const shipView = GetShipView();
  const t = app.getT("TripView");
  const calculated = trip.calculated;
  const { writers } = useTripData();

  return (
    <div className="TripView-details">
      <TabBar defaultSelection={initTab || "trip"} callbacks={tabBarRef} tabs={[
        { icon: Icons.Trip, name: "trip", title: t("tab_trip"), render: () => {
          return <TripEditView cruiseId={trip.cruiseId} trip={trip} />;
        } },
        { icon: Icons.Stats, name: "stats", title: t("tab_stats"), render: () => {
          return <StatsView trip={trip} calculate={writers.calculateTrip} />;
        } },
        { icon: Icons.Track, name: "track", title: t("tab_track"), render: () => {
          return (
            <div className="TripView-track">
              <TrackView fullscreen={false} tracks={tracks} timezone={trip.timezone} />
            </div>
          );
        } },
        { hide: !calculated || !calculated.weatherTimeseries, icon: Icons.Graph, name: "weather", title: t("tab_weather"), render: () => {
          return <GraphView timeseries={calculated?.weatherTimeseries} />;
        } },
        ...(
          NoteTabs(app, INoteParentType.trip, trip.notes || [])
        ),
        { icon: Icons.Print, name: "print", title: t("tab_print"), render: () => {
          return (
            <div className="TripView-print-tab">
              <BlockRow className="block-row-button-print">
                <button className="button " onClick={() => {
                  shipView.setPrinting(PrintMode.trips, cruise);
                }}
                >
                  <Icon icon={Icons.Print} className="icon-large" /> {t("print_all")}
                </button>
              </BlockRow>
              <BlockRow className="block-row-button-print">
                <button className="button " onClick={() => {
                  shipView.setPrinting(PrintMode.trips, cruise, trip.id);
                }}
                >
                  <Icon icon={Icons.Print} className="icon-large" /> {t("print_trip")}
                </button>
              </BlockRow>
            </div>
          );
        } },
      ]}
      />
    </div>
  );
}
